import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };



  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__content">
          <p className="footer__copyright">
            &copy; {new Date().getFullYear()} abdul-latif sadiq. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;